export default __webpack_public_path__ + "static/media/server-type.dea14903.svg";